import { useAxiosWrapper } from "../../services/axiosWrapper";
import { useBaseActions } from "../base.actions";

export enum DataPublicacaoRange {
  Ultimos7Dias = 'Ultimos7Dias',
  Ultimos15Dias = 'Ultimos15Dias',
  Ultimos30Dias = 'Ultimos30Dias'
}

export enum ModeloTrabalho {
  Presencial = 'Presencial',
  Hibrido = 'Híbrido',
  Remoto = 'Remoto'
}

export enum Origem {
  Guppy = 'Guppy',
  Catho = 'Catho'
}

export interface IVagasExternasFilter {
  pagina?: number;
  tamanhoPagina?: number;
  titulo?: string;
  area?: string;
  faixaSalarial?: string;
  localidade?: string;
  dataPublicacao?: DataPublicacaoRange;
  modeloTrabalho?: ModeloTrabalho;
  senioridade?: string;
  origem?: Origem;
}

export function useVagaExternaActions() {
  const axiosWrapper = useAxiosWrapper();
  const baseUrl = `${process.env.REACT_APP_API_URL}/v1/vagasExternas`;

  return {
    internalizar: internalizar,
    filter: filter,
    notificarAcao: notificarAcao
  };


  async function internalizar(id: number, idEmpresa: number, idResponsavel: number) {
    return await axiosWrapper.post(`${baseUrl}/internalizar`,
      { idVagaExterna: id, idEmpresaRelacionamento: idEmpresa, idResponsavel }
    );
  }
  
  async function filter(filterParams: IVagasExternasFilter, salvarNoState = false) {
    const queryParams = new URLSearchParams();
    
    if (filterParams.pagina) queryParams.append('pagina', filterParams.pagina.toString());
    if (filterParams.tamanhoPagina) 
      queryParams.append('tamanhoPagina', filterParams.tamanhoPagina.toString());
    
    if (filterParams.titulo) queryParams.append('titulo', filterParams.titulo);
    if (filterParams.area) queryParams.append('area', filterParams.area);
    if (filterParams.faixaSalarial) queryParams.append('faixaSalarial', filterParams.faixaSalarial);
    if (filterParams.localidade) queryParams.append('localidade', filterParams.localidade);
    if (filterParams.dataPublicacao) 
      queryParams.append('dataPublicacao', filterParams.dataPublicacao);
    if (filterParams.modeloTrabalho) 
      queryParams.append('modeloTrabalho', filterParams.modeloTrabalho);
    
    if (filterParams.senioridade) queryParams.append('senioridade', filterParams.senioridade);
    if (filterParams.origem) queryParams.append('origem', filterParams.origem);
    
    const queryString = queryParams.toString() ? `?${queryParams.toString()}` : '';
    return await axiosWrapper.get(`${baseUrl}${queryString}`);
  }

  async function notificarAcao(contatoId: number, id: number) {
    return await axiosWrapper.post(`${baseUrl}/notificar-acao/${contatoId}/${id}`);
  }
}
